import { clsx } from 'clsx'

import { FC, ReactNode } from 'react'

import { IClassName } from '@/app/shared/interfaces/common.interface'

//interface
interface IContainerProps extends IClassName {
  children: ReactNode
  id?: string
}

//component
const ContainerComponent: FC<Readonly<IContainerProps>> = ({ children, className, id }) => {
  //return
  return (
    <div id={id} className={clsx('px-6 laptop:px-[180px] desktop:px-[220px]', className)}>
      {children}
    </div>
  )
}

export default ContainerComponent
